<template>

    <div class="home_w">
      <main>
        <div class="div_1 site_content">
          <div class="div_2 d_flex justify_content_sb">
            <!-- 新闻中心 -->
            <NewCenter />

            <MapNav />

          </div>

          <!-- 广告轮播 -->
          <Adverts code="index-carousel" />


          <!-- 竞价大厅 -->
          <Auction />

           <!-- 竞拍流程 -->
          <DealProcess />

          <!-- 项目公告 -->
          <Project />

          <div
            class=" d_flex justify_content_sb"
          >
            <!-- 通知公告 -->
            <cmsArticleTabs cmsNodeCode="notice"/>

            <div style="margin:0 10px"></div>
            <!-- 政策法规 -->
            <cmsArticleTabs cmsNodeCode="statute"/>

          </div>

          <!-- 统一规范 -->
          <div class="unified_w" :style="{'background':`url(${oss_pub_domain}site/article/cover/wB6cGD8eVBF96EJA.png) 0 center no-repeat`}"/>


        </div>
      </main>
    </div>
</template>

<script>
import NewCenter from "@/views/public_0983cc/home/public/NewCenter.vue";
import Auction from "@/views/public_0983cc/home/public/Auction.vue";
import DealProcess from "@/views/public_0983cc/home/public/DealProcess.vue";
import Adverts from "@/views/public_0983cc/home/public/Adverts.vue";
import Project from "@/views/public_0983cc/home/public/Project.vue";


import MapNav from "../diffview/MapNav.vue";
import cmsArticleTabs from "@/components/template/cmsArticleTabs.vue";

import { mapGetters,mapActions } from "vuex";


export default {
  name: 'Async',
  components: {
    NewCenter,
    Auction,
    DealProcess,
    Adverts,
    MapNav,
    cmsArticleTabs,
    Project
  },
  metaInfo() {
    return {
            title: `${this.siteInfo?.name} - 农村综合产权流转交易服务平台 - 农村集体资产交易网`,
            meta: [
              {
                name: "keywords",
                content: `${this.siteInfo?.name},农村产权交易平台,农村综合产权流转交易服务平台,农村集体资产交易服务平台,土地流转交易网,土地拍卖网`,
              },
              {
                name: "description",
                content: `${this.siteInfo?.name}经人民政府批准设立，唯一指定的农村综合产权交易服务平台，平台以公开、公平、公正为原则，以“让土地增值，让农民增收”为宗旨，促进城乡要素跨区域流动，助力乡村振兴。`,
              },
            ],
          };
  },
  inject: ["reload"],
  computed: {
    ...mapGetters(["siteInfo",'oss_pub_domain']),
  },
  created(){
    this.initIndexAdverts('index')
  },
  methods:{
    ...mapActions({
      'initIndexAdverts': 'cache/initIndexAdverts'
    }),
  }

};
</script>

<style lang="scss" scoped>
.home_w {
  .div_1 {
    margin-top: 23px;
  }
  .div_2 {
    margin: 0 0 10px 0;
  }
  .unified_w {
    height: 100px;
    margin: 10px 0;
  }

}
</style>
